import { render, staticRenderFns } from "./Typo.vue?vue&type=template&id=468d699a&scoped=true"
import script from "./Typo.vue?vue&type=script&lang=js"
export * from "./Typo.vue?vue&type=script&lang=js"
import style0 from "./Typo.vue?vue&type=style&index=0&id=468d699a&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "468d699a",
  null
  
)

export default component.exports